// SNL Cast Members card game data - ranked by fame/cultural impact
export const SNL_CAST_CARDS = [
  { id: 1, name: "Eddie Murphy", rank: 1, image: "/images/snlCast/snlCast_1.jpg" },
  { id: 2, name: "Will Ferrell", rank: 2, image: "/images/snlCast/snlCast_2.jpg" },
  { id: 3, name: "Adam Sandler", rank: 3, image: "/images/snlCast/snlCast_3.jpg" },
  { id: 4, name: "Tina Fey", rank: 4, image: "/images/snlCast/snlCast_4.jpg" },
  { id: 5, name: "Bill Murray", rank: 5, image: "/images/snlCast/snlCast_5.jpg" },
  { id: 6, name: "Dan Aykroyd", rank: 6, image: "/images/snlCast/snlCast_6.jpg" },
  { id: 7, name: "Chevy Chase", rank: 7, image: "/images/snlCast/snlCast_7.jpg" },
  { id: 8, name: "John Belushi", rank: 8, image: "/images/snlCast/snlCast_8.jpg" },
  { id: 9, name: "Mike Myers", rank: 9, image: "/images/snlCast/snlCast_9.jpg" },
  { id: 10, name: "Chris Farley", rank: 10, image: "/images/snlCast/snlCast_10.jpg" },
  { id: 11, name: "Amy Poehler", rank: 11, image: "/images/snlCast/snlCast_11.jpg" },
  { id: 12, name: "Kristen Wiig", rank: 12, image: "/images/snlCast/snlCast_12.jpg" },
  { id: 13, name: "Julia Louis-Dreyfus", rank: 13, image: "/images/snlCast/snlCast_13.jpg" },
  { id: 14, name: "Dana Carvey", rank: 14, image: "/images/snlCast/snlCast_14.jpg" },
  { id: 15, name: "Phil Hartman", rank: 15, image: "/images/snlCast/snlCast_15.jpg" },
  { id: 16, name: "Chris Rock", rank: 16, image: "/images/snlCast/snlCast_16.jpg" },
  { id: 17, name: "Gilda Radner", rank: 17, image: "/images/snlCast/snlCast_17.jpg" },
  { id: 18, name: "Jimmy Fallon", rank: 18, image: "/images/snlCast/snlCast_18.jpg" },
  { id: 19, name: "Seth Meyers", rank: 19, image: "/images/snlCast/snlCast_19.jpg" },
  { id: 20, name: "Andy Samberg", rank: 20, image: "/images/snlCast/snlCast_20.jpg" },
  { id: 21, name: "Bill Hader", rank: 21, image: "/images/snlCast/snlCast_21.jpg" },
  { id: 22, name: "Tracy Morgan", rank: 22, image: "/images/snlCast/snlCast_22.jpg" },
  { id: 23, name: "Maya Rudolph", rank: 23, image: "/images/snlCast/snlCast_23.jpg" },
  { id: 24, name: "Jason Sudeikis", rank: 24, image: "/images/snlCast/snlCast_24.jpg" },
  { id: 25, name: "Kenan Thompson", rank: 25, image: "/images/snlCast/snlCast_25.jpg" },
  { id: 26, name: "Kate McKinnon", rank: 26, image: "/images/snlCast/snlCast_26.jpg" },
  { id: 27, name: "Pete Davidson", rank: 27, image: "/images/snlCast/snlCast_27.jpg" },
  { id: 28, name: "David Spade", rank: 28, image: "/images/snlCast/snlCast_28.jpg" },
  { id: 29, name: "Jan Hooks", rank: 29, image: "/images/snlCast/snlCast_29.jpg" },
  { id: 30, name: "Norm Macdonald", rank: 30, image: "/images/snlCast/snlCast_30.jpg" }
];
